import { radioCardAnatomy } from "@chakra-ui/react/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react/styled-system";
import { interactiveTransition } from "./_shared";

export default defineSlotRecipe({
  slots: radioCardAnatomy.keys(),
  base: {
    root: {
      gap: 3,
    },
    item: {
      ...interactiveTransition,
      cursor: "pointer",
    },
    // The stock recipe ties content alignment to the `align` variant, which
    // also centres the text. Cards here read as a row — leading icon, copy,
    // trailing indicator — so the row centres while the copy stays start-aligned.
    itemControl: {
      alignItems: "center",
      textAlign: "start",
    },
    itemDescription: {
      textStyle: "body.sm",
      color: "fg.muted",
      opacity: 1,
    },
  },
});
